<div class="aside-scroll">
    <ul>
        <!-- Pages Start -->
        <li class="menu-section-title">Pages</li>
        <li class="menu-item" [ngClass]="item.child == true ? 'menu-item-has-children' : ''"
            *ngFor="let item of navigation">
            <a href="javascript:void(0)" (click)="trigger(item)" *ngIf="item.child"><i class="flaticon-{{item.icon}}"></i>{{item.linkText}}</a>
            <a routerLink="{{item.link}}" *ngIf="!item.child"><i class="flaticon-{{item.icon}}"></i>{{item.linkText}}</a>
            <ul class="submenu" *ngIf="item.child" [ngClass]="item.open ? 'd-block' : ''">
                <li class="menu-item" [ngClass]="item.child == true ? 'menu-item-has-children' : ''"
                    *ngFor="let item of item.submenu">
                    <a href="javascript:void(0)" (click)="trigger(item)" *ngIf="item.child">{{item.linkText}}</a>
                    <a routerLink="{{item.link}}" *ngIf="!item.child">{{item.linkText}}</a>
                    <ul class="submenu" *ngIf="item.child" [ngClass]="item.open ? 'd-block' : ''">
                        <li class="menu-item" *ngFor="let item of item.submenu">
                            <a routerLink="{{item.link}}">{{item.linkText}}</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
        <!-- Pages End -->
        <!-- Social Media Start -->
        <li class="menu-section-title">Get Social</li>
        <li class="menu-item"> <a routerLink="/"> <i class="flaticon-facebook"></i>Facebook</a> </li>
        <li class="menu-item"> <a routerLink="/"> <i class="flaticon-linkedin"></i> Linkedin </a> </li>
        <li class="menu-item"> <a routerLink="/"> <i class="flaticon-twitter"></i> Twitter </a> </li>
        <li class="menu-item"> <a routerLink="/"> <i class="flaticon-instagram"></i> Instagram </a> </li>
        <!-- Social Media End -->
    </ul>
</div>